export function validateAndReturnDivisionNumber(number: number) {
    if (number > 1000000) {
        return 1000000;
    }
    if (number < 1000000 && number >= 1000) {
        return 1000;
    }
    return 1;
}
